/* CANFOTO ETAP 2 — R9 PRODUCT TYPE EXTENSION V1
   Sealed Standard Collections + native Product Type T1/T2/T3/T4.
   Product Type: exact request/current_type registry, BICOLOR_ONLY_V1 selector capability, q preservation,
   native server source order -> exact R8 canonical prefix -> stable unscored tail -> pagination/render.
   Score display is integer-only; exact raw R8 score remains audit data and ranking truth. */
(()=>{
'use strict';
const VERSION='CANFOTO-ETAP2-V66G-PANEL-BARE-LIVE-R9-V1';
const URL_PARENT='cf_nora_purpose';
const URL_CHILD='cf_nora_sub';
const clean=v=>String(v??'').replace(/\s+/g,' ').trim();
const sleep=ms=>new Promise(r=>setTimeout(r,ms));
const all=(root,sel)=>Array.from(root.querySelectorAll(sel));
const displayScore=v=>Number.isFinite(Number(v))?String(Math.round(Number(v))):'';
const rawScore=v=>Number.isFinite(Number(v))?String(Number(v)):'';
const membershipCache=new Map();
const BICOLOR_POLICY=Object.freeze({
  PANEL:Object.freeze({
    expectedSourceCount:25,expectedParentCount:7,expectedChildCount:21,
    allowed:Object.freeze([
      'product_ecommerce::small_product_tabletop','product_ecommerce::large_product_model','product_ecommerce::marketplace_catalog',
      'youtube_reels_social::single_person_video','youtube_reels_social::reels_tiktok_short','youtube_reels_social::live_stream_talk',
      'interview_talking_head::single_interview','interview_talking_head::two_person_interview','interview_talking_head::corporate_training',
      'clinic_aesthetic_dental::skin_face_shoot','clinic_aesthetic_dental::dental_support','clinic_aesthetic_dental::clinic_social_content',
      'studio_professional::model_shoot','studio_professional::ad_campaign_visual','studio_professional::fixed_studio_setup',
      'mobile_outdoor::battery_shoot','mobile_outdoor::portable_team','mobile_outdoor::fast_location_setup',
      'starter_budget_practical::first_light_choice','starter_budget_practical::budget_setup','starter_budget_practical::compact_solution'
    ]),
    blocked:Object.freeze([
      'rgb_creative_video::background_color_effect','rgb_creative_video::music_clip_creative_scene',
      'rgb_creative_video::product_color_separation','rgb_creative_video::subject_rim_edge'
    ])
  }),
  COB:Object.freeze({
    expectedSourceCount:36,expectedParentCount:9,expectedChildCount:32,
    allowed:Object.freeze([
      'youtube_reels_single_person','podcast_audio_sensitive','webinar_online_course','room_natural_background',
      'single_person_interview','corporate_talking_head','two_person_interview_key_start',
      'tabletop_small_product','catalog_white_background_key','product_video_reels','reflective_jewelry_glossy','food_culinary','cosmetics_packaging_color',
      'portrait_headshot','fashion_model_key','makeup_beauty','hair_salon_content','baby_family_soft_key',
      'dental_closeup_documentation','clinical_aesthetic_before_after','procedure_technical_closeup',
      'live_sales_face_product','showroom_demo','field_interview','travel_vlog_creator','location_portrait_video',
      'studio_key_light','large_softbox_key','film_video_production_key','technical_product_document_archive','workshop_handcraft_training','diy_how_to'
    ]),
    blocked:Object.freeze(['brand_color_live_background','rgb_background_edge_brand','music_video_color_scene','projection_gobo_pattern'])
  })
});
const COPY_VERSION='CANFOTO-ETAP2-R4-PA-P1.20H-WEB-USER-LANGUAGE-V1';
const PURPOSE_COPY=Object.freeze({
  COB:Object.freeze({
    content_creation_desk:Object.freeze({full:'YouTube/Reels, podcast, webinar ve doğal oda fonlu masa başı içerikleri.',bicolor:'YouTube/Reels, podcast, webinar ve doğal oda fonlu masa başı içerikleri.'}),
    interview_corporate:Object.freeze({full:'Tek/iki kişilik röportaj, talking-head ve kurumsal anlatım çekimleri.',bicolor:'Tek/iki kişilik röportaj, talking-head ve kurumsal anlatım çekimleri.'}),
    product_ecommerce:Object.freeze({full:'Tabletop ürün, beyaz fon katalog, ürün videosu, takı, gıda ve renk doğruluğu gereken ambalaj çekimleri.',bicolor:'Tabletop ürün, beyaz fon katalog, ürün videosu, takı, gıda ve renk doğruluğu gereken ambalaj çekimleri.'}),
    portrait_model_beauty:Object.freeze({full:'Portre/headshot, moda-model, makyaj, saç-salon ve bebek/aile çekimleri.',bicolor:'Portre/headshot, moda-model, makyaj, saç-salon ve bebek/aile çekimleri.'}),
    clinical_dental_documentation:Object.freeze({full:'Dental yakın plan, estetik öncesi-sonrası ve teknik prosedür kayıtları.',bicolor:'Dental yakın plan, estetik öncesi-sonrası ve teknik prosedür kayıtları.'}),
    live_sales_showroom:Object.freeze({full:'Yüz + ürün odaklı canlı satış, showroom/demo ve marka renkli fon kullanılan yayınlar.',bicolor:'Yüz + ürün odaklı canlı satış ve showroom/demo çekimleri.'}),
    mobile_location:Object.freeze({full:'Saha röportajı, seyahat/VLOG ve lokasyon portre-video çekimleri.',bicolor:'Saha röportajı, seyahat/VLOG ve lokasyon portre-video çekimleri.'}),
    rgb_creative:Object.freeze({full:'RGB fon/kenar, müzik videosu ve projeksiyon/gobo efektli kreatif çekimler.',bicolor:''}),
    studio_production:Object.freeze({full:'Stüdyo ana ışığı, büyük softbox ve film/video prodüksiyon çekimleri.',bicolor:'Stüdyo ana ışığı, büyük softbox ve film/video prodüksiyon çekimleri.'}),
    technical_archive_workshop:Object.freeze({full:'Teknik ürün-belge kayıtları, atölye eğitimleri ve nasıl yapılır içerikleri.',bicolor:'Teknik ürün-belge kayıtları, atölye eğitimleri ve nasıl yapılır içerikleri.'})
  }),
  PANEL:Object.freeze({
    product_ecommerce:Object.freeze({full:'Küçük/masaüstü ürün, büyük ürün-model ve pazar yeri/katalog çekimleri.',bicolor:'Küçük/masaüstü ürün, büyük ürün-model ve pazar yeri/katalog çekimleri.'}),
    youtube_reels_social:Object.freeze({full:'Tek kişi video, Reels/TikTok ve yayın/canlı anlatım içerikleri.',bicolor:'Tek kişi video, Reels/TikTok ve yayın/canlı anlatım içerikleri.'}),
    interview_talking_head:Object.freeze({full:'Tek/iki kişi röportaj ve kurumsal video/eğitim çekimleri.',bicolor:'Tek/iki kişi röportaj ve kurumsal video/eğitim çekimleri.'}),
    clinic_aesthetic_dental:Object.freeze({full:'Cilt/yüz, dental yakın plan ve klinik sosyal medya içerikleri.',bicolor:'Cilt/yüz, dental yakın plan ve klinik sosyal medya içerikleri.'}),
    rgb_creative_video:Object.freeze({full:'Arka plan renk efekti, müzik/klip, ürün renk ayrımı ve kişi/model kontur vurgusu.',bicolor:''}),
    studio_professional:Object.freeze({full:'Model, reklam/kampanya ve sabit stüdyo setup\'ları.',bicolor:'Model, reklam/kampanya ve sabit stüdyo setup\'ları.'}),
    mobile_outdoor:Object.freeze({full:'Bataryalı çekim, taşınabilir ekip ve hızlı lokasyon setup\'ları.',bicolor:'Bataryalı çekim, taşınabilir ekip ve hızlı lokasyon setup\'ları.'}),
    starter_budget_practical:Object.freeze({full:'İlk ışık seçimi, uygun fiyatlı setup ve az yer kaplayan çözümler.',bicolor:'İlk ışık seçimi, uygun fiyatlı setup ve az yer kaplayan çözümler.'})
  })
});
const SUBPURPOSE_COPY=Object.freeze({
  COB:Object.freeze({
    youtube_reels_single_person:'Tek kişinin kameraya konuştuğu sosyal video içerikleri.',
    podcast_audio_sensitive:'Konuşma ve ses kaydında sessiz çalışma gerektiren içerikler.',
    webinar_online_course:'Webinar, online ders ve anlatıcı odaklı eğitim çekimleri.',
    room_natural_background:'Mekânı ve doğal arka planı kadraja alan içerikler.',
    single_person_interview:'Tek kişinin kadrajda olduğu röportaj çekimleri.',
    corporate_talking_head:'Kameraya doğrudan anlatım yapılan kurumsal videolar.',
    two_person_interview_key_start:'İki kişilik röportajda ana ışık başlangıcı için.',
    tabletop_small_product:'Masaüstünde küçük ürün fotoğrafı ve videosu.',
    catalog_white_background_key:'Beyaz fonlu katalog çekiminde ana ışık ihtiyacı.',
    product_video_reels:'Ürün odaklı kısa video ve Reels içerikleri.',
    reflective_jewelry_glossy:'Parlak yüzey, metal, takı ve yansıma kontrolü gerektiren çekimler.',
    food_culinary:'Yemek, gıda ve masaüstü sunum çekimleri.',
    cosmetics_packaging_color:'Kozmetik ve ambalajda doğru renk aktarımı gereken çekimler.',
    portrait_headshot:'Yüz ve üst gövde odaklı tek kişi portreleri.',
    fashion_model_key:'Moda ve model çekiminde ana ışık ihtiyacı.',
    makeup_beauty:'Makyaj ve beauty çekimlerinde yüz/ten odaklı ışık.',
    hair_salon_content:'Saç, kuaför ve salon hizmetlerini gösteren içerikler.',
    baby_family_soft_key:'Bebek ve aile çekimlerinde yumuşak ana ışık.',
    dental_closeup_documentation:'Dental uygulamalarda yakın plan fotoğraf ve video kaydı.',
    clinical_aesthetic_before_after:'Klinik ve estetik uygulamalarda karşılaştırılabilir önce/sonra kaydı.',
    procedure_technical_closeup:'Prosedür ve teknik uygulamalarda detay odaklı video.',
    live_sales_face_product:'Canlı satışta yüz ve ürünü birlikte öne çıkaran ana ışık.',
    showroom_demo:'Showroom, demo ve ürün anlatım videoları.',
    brand_color_live_background:'Marka rengiyle oluşturulan fonlu canlı yayın.',
    field_interview:'Stüdyo dışındaki röportaj ve saha çekimleri.',
    travel_vlog_creator:'Seyahat, VLOG ve mobil creator içerikleri.',
    location_portrait_video:'Lokasyonda portre ve kişi odaklı video çekimleri.',
    rgb_background_edge_brand:'RGB fon, kenar ayrımı ve marka rengi uygulamaları.',
    music_video_color_scene:'Müzik videosu ve renkli kreatif sahneler.',
    projection_gobo_pattern:'Projeksiyon, gobo ve desen efektleri kullanılan sahneler.',
    studio_key_light:'Stüdyo çekimlerinde ana ışık ihtiyacı.',
    large_softbox_key:'Büyük softbox ile geniş ve yumuşak ana ışık.',
    film_video_production_key:'Film ve video prodüksiyonunda ana ışık ihtiyacı.',
    technical_product_document_archive:'Teknik ürün, belge ve arşiv dokümantasyonu.',
    workshop_handcraft_training:'Atölye, el işi ve masaüstü eğitim içerikleri.',
    diy_how_to:'Adım adım uygulama ve nasıl yapılır içerikleri.'
  }),
  PANEL:Object.freeze({
    'product_ecommerce::small_product_tabletop':'Masaüstünde küçük ürün fotoğrafı ve videosu.',
    'product_ecommerce::large_product_model':'Büyük ürünleri tek başına veya model üzerinde çekme.',
    'product_ecommerce::marketplace_catalog':'Pazar yeri ve katalog için temiz ürün görselleri.',
    'youtube_reels_social::single_person_video':'Tek kişinin kameraya konuştuğu video içerikleri.',
    'youtube_reels_social::reels_tiktok_short':'Kısa dikey sosyal medya videoları.',
    'youtube_reels_social::live_stream_talk':'Canlı yayın ve kameraya anlatım içerikleri.',
    'interview_talking_head::single_interview':'Tek kişinin kadrajda olduğu röportaj.',
    'interview_talking_head::two_person_interview':'İki kişinin birlikte kadrajda olduğu röportaj.',
    'interview_talking_head::corporate_training':'Kurumsal anlatım, eğitim ve bilgilendirme videoları.',
    'clinic_aesthetic_dental::skin_face_shoot':'Cilt, yüz ve estetik uygulama odaklı çekimler.',
    'clinic_aesthetic_dental::dental_support':'Dental ve ağız içi yakın plan çekim desteği.',
    'clinic_aesthetic_dental::clinic_social_content':'Klinik ve estetik alanında sosyal medya çekimleri.',
    'rgb_creative_video::background_color_effect':'Arka planda kontrollü renk ve atmosfer oluşturma.',
    'rgb_creative_video::music_clip_creative_scene':'Müzik, klip ve kreatif renkli sahneler.',
    'rgb_creative_video::product_color_separation':'Ürünü arka plandan renk ile ayırma.',
    'studio_professional::model_shoot':'Stüdyoda model ve kişi çekimleri.',
    'studio_professional::ad_campaign_visual':'Reklam ve kampanya için kontrollü stüdyo çekimleri.',
    'studio_professional::fixed_studio_setup':'Tekrarlanabilir sabit stüdyo setup\'ları.',
    'mobile_outdoor::battery_shoot':'Prizden bağımsız batarya destekli çekimler.',
    'mobile_outdoor::portable_team':'Hafif ve taşınabilir ekipmanla mobil çekimler.',
    'mobile_outdoor::fast_location_setup':'Lokasyonda hızlı kurulup toplanabilen setup.',
    'starter_budget_practical::first_light_choice':'İlk sürekli ışığını seçen kullanıcılar için.',
    'starter_budget_practical::budget_setup':'Bütçeyi gözeten işlevsel setup seçenekleri.',
    'starter_budget_practical::compact_solution':'Dar alanlarda kompakt ışık çözümü.',
    'rgb_creative_video::subject_rim_edge':'Kişi veya modeli fondan kenar ışığıyla ayırma.'
  })
});
function parentDescription(engine,key,capability){
  const row=PURPOSE_COPY[engine]?.[key];
  if(!row) return '';
  return clean(capability==='BICOLOR_ONLY_V1'?row.bicolor:row.full);
}
function childDescription(engine,key){return clean(SUBPURPOSE_COPY[engine]?.[key]);}

function applyCapabilityPolicy(engine,taxonomy,profile){
  const sourceKeys=taxonomy.flatMap(p=>p.children.map(c=>c.key));
  if(profile==='FULL_R8') return {taxonomy,audit:{profile,sourceCount:sourceKeys.length,allowedCount:sourceKeys.length,blockedCount:0,unknown:[],missingKnown:[]}};
  if(profile!=='BICOLOR_ONLY_V1') throw new Error('R9_UNKNOWN_CAPABILITY_PROFILE_'+profile);
  const policy=BICOLOR_POLICY[engine];if(!policy) throw new Error('R9_BICOLOR_ENGINE_UNSUPPORTED_'+engine);
  const allowed=new Set(policy.allowed),blocked=new Set(policy.blocked),known=new Set([...allowed,...blocked]);
  const unknown=sourceKeys.filter(k=>!known.has(k));
  const missingKnown=[...known].filter(k=>!sourceKeys.includes(k));
  if(sourceKeys.length!==policy.expectedSourceCount||unknown.length||missingKnown.length) throw new Error('R9_BICOLOR_POLICY_COVERAGE_HOLD');
  const filtered=taxonomy.map(p=>({...p,children:p.children.filter(c=>allowed.has(c.key))})).filter(p=>p.children.length);
  const childCount=filtered.reduce((n,p)=>n+p.children.length,0);
  if(filtered.length!==policy.expectedParentCount||childCount!==policy.expectedChildCount) throw new Error('R9_BICOLOR_POLICY_COUNT_HOLD');
  return {taxonomy:filtered,audit:{profile,sourceCount:sourceKeys.length,allowedCount:childCount,blockedCount:policy.blocked.length,unknown,missingKnown}};
}

function closePopovers(root){
  all(root,'.cf-nora-r9__field.is-open').forEach(x=>x.classList.remove('is-open'));
  all(root,'[data-cf-nora-opener][aria-expanded="true"]').forEach(x=>x.setAttribute('aria-expanded','false'));
}
function setGuide(root,state){
  all(root,'.cf-nora-r9__field').forEach(x=>x.classList.remove('guide-focus'));
  if(!state.parentKey) root.querySelector('[data-cf-nora-field="purpose"]')?.classList.add('guide-focus');
  else if(!state.childKey) root.querySelector('[data-cf-nora-field="sub"]')?.classList.add('guide-focus');
}
function fingerprintDomOrder(){
  return all(document,'.cf-unified-product-card[data-cf-ucard-handle]').map(x=>clean(x.dataset.cfUcardHandle));
}
function sameOrder(a,b){return a.length===b.length&&a.every((v,i)=>v===b[i]);}
async function sha256Text(text){
  if(!crypto?.subtle) return 'NO_SUBTLE_CRYPTO';
  const buf=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(text));
  return [...new Uint8Array(buf)].map(b=>b.toString(16).padStart(2,'0')).join('');
}

function buildPanelTaxonomy(){
  const rows=window.CANFOTO_R8_PANEL_RANKING_SNAPSHOT?.data?.selections;
  if(!Array.isArray(rows)||rows.length!==25) throw new Error('R9_PANEL_SNAPSHOT_25_REQUIRED');
  const map=new Map();
  rows.forEach((x,index)=>{
    const parentKey=clean(x.purposeKey);
    if(!map.has(parentKey)) map.set(parentKey,{key:parentKey,label:clean(x.purposeTitle),order:index,children:[]});
    map.get(parentKey).children.push({key:clean(x.selectionKey),label:clean(x.subPurposeTitle),order:index});
  });
  return [...map.values()];
}
function buildCobTaxonomy(){
  const rows=window.CANFOTO_R8_COB_RANKING_SNAPSHOT?.data?.purposeDefs;
  if(!Array.isArray(rows)||rows.length!==36) throw new Error('R9_COB_PURPOSE_DEFS_36_REQUIRED');
  const sorted=rows.slice().sort((a,b)=>Number(a.mainOrder)-Number(b.mainOrder)||Number(a.subOrder)-Number(b.subOrder));
  const map=new Map();
  sorted.forEach(x=>{
    const parentKey=clean(x.mainKey);
    if(!map.has(parentKey)) map.set(parentKey,{key:parentKey,label:clean(x.mainLabel),order:Number(x.mainOrder),children:[]});
    map.get(parentKey).children.push({key:clean(x.purposeKey),label:clean(x.purposeLabel),order:Number(x.subOrder)});
  });
  return [...map.values()].sort((a,b)=>a.order-b.order);
}
function shortLabel(v){return clean(v).replace(/\s*\/\s*/g,' / ');}
function makeChoice({key,label,parent=false,pressed=false,description=''}){
  const b=document.createElement('button');
  b.type='button';
  b.className='cf-nora-r9__choice '+(parent?'cf-nora-r9__choice--parent':'cf-nora-r9__choice--child');
  b.dataset.cfNoraChoice=parent?'parent':'child';
  b.dataset.cfNoraKey=key;
  b.setAttribute('role','option');
  b.setAttribute('aria-pressed',String(pressed));
  const strong=document.createElement('b');strong.className='cf-nora-r9__choice-title';strong.textContent=label;
  b.appendChild(strong);
  if(description){
    const span=document.createElement('span');span.className='cf-nora-r9__choice-desc';span.textContent=description;b.appendChild(span);
  }
  return b;
}
function pageFromUrl(url=location.href){
  const p=Number(new URL(url,location.origin).searchParams.get('page')||1);
  return Number.isFinite(p)&&p>0?Math.floor(p):1;
}
function sectionId(root){
  const form=document.querySelector('form[is="facet-form"]');
  const viaTheme=window.theme?.utils?.sectionId?.(form);
  if(viaTheme) return clean(viaTheme);
  return clean(root.id).replace(/^CfNoraR9-/,'');
}
function sourceBaseUrl(){
  const url=new URL(location.href);
  ['page','section_id','sort_by',URL_PARENT,URL_CHILD].forEach(k=>url.searchParams.delete(k));
  url.hash='';
  return url;
}
function withSection(url,section,page=1){
  const u=new URL(url.toString());
  u.searchParams.set('page',String(page));
  u.searchParams.set('section_id',section);
  return u;
}
function maxPageFromDoc(doc){
  let max=1;
  all(doc,'#ProductGridContainer a[href]').forEach(a=>{
    try{max=Math.max(max,pageFromUrl(new URL(a.getAttribute('href'),location.origin).toString()));}catch(_e){}
  });
  return max;
}
function productCardsFromDoc(doc){
  return all(doc,'#ProductGridContainer .cf-unified-product-card[data-cf-ucard-handle]');
}
async function fetchDoc(url){
  const r=await fetch(url.toString(),{credentials:'same-origin'});
  if(!r.ok) throw new Error('R9_SOURCE_FETCH_HTTP_'+r.status);
  return new DOMParser().parseFromString(await r.text(),'text/html');
}
async function getFullMembership(root,{force=false}={}){
  const sid=sectionId(root);
  if(!sid) throw new Error('R9_SECTION_ID_MISSING');
  const base=sourceBaseUrl();
  const cacheKey=base.pathname+'?'+[...base.searchParams.entries()].sort().map(([k,v])=>encodeURIComponent(k)+'='+encodeURIComponent(v)).join('&');
  if(!force&&membershipCache.has(cacheKey)) return membershipCache.get(cacheKey);

  const firstDoc=await fetchDoc(withSection(base,sid,1));
  const maxPage=maxPageFromDoc(firstDoc);
  const docs=[firstDoc];
  for(let p=2;p<=maxPage;p++) docs.push(await fetchDoc(withSection(base,sid,p)));

  const cardsByHandle=new Map();
  const handles=[];
  docs.forEach(doc=>{
    productCardsFromDoc(doc).forEach(card=>{
      const h=clean(card.dataset.cfUcardHandle);
      if(!h||cardsByHandle.has(h)) return;
      handles.push(h);
      cardsByHandle.set(h,card.outerHTML);
    });
  });
  const firstPageProductCount=productCardsFromDoc(firstDoc).length;
  const fp=await sha256Text(handles.join('\n'));
  const row=Object.freeze({
    cacheKey,baseUrl:base.toString(),sectionId:sid,maxPage,firstPageProductCount,
    handles:Object.freeze(handles.slice()),cardsByHandle,sourceOrderFingerprint:fp,
    sourceOwner:clean(root.dataset.cfNoraSurfaceKind)==='PRODUCT_TYPE'?'SHOPIFY_PRODUCT_TYPE_NATIVE_SERVER_ORDER':'SHOPIFY_COLLECTION_DEFAULT_SERVER_ORDER'
  });
  membershipCache.set(cacheKey,row);
  return row;
}
function setRankingBusy(root,on){
  root.dataset.cfNoraRankingBusy=on?'true':'false';
  document.documentElement.dataset.cfNoraRankingBusy=on?'1':'0';
}
function updateSortUiFromDoc(doc){
  const live=document.getElementById('SortByContainer');
  const fresh=doc.getElementById('SortByContainer');
  if(live&&fresh) live.innerHTML=fresh.innerHTML;
}
function rewritePaginationLinks(container,state){
  all(container,'a[href]').forEach(a=>{
    const href=a.getAttribute('href');
    if(!href) return;
    let u; try{u=new URL(href,location.origin);}catch(_e){return;}
    if(!u.searchParams.has('page')) return;
    u.searchParams.set(URL_PARENT,state.parentKey);
    u.searchParams.set(URL_CHILD,state.childKey);
    a.href=u.pathname+u.search+u.hash;
  });
}
function buildRankedMotionList(sourceMotion,rankedHtml){
  const out=sourceMotion.cloneNode(true);
  let i=0;
  Array.from(out.children).forEach(child=>{
    if(!child.matches('.cf-unified-product-card[data-cf-ucard-handle]')) return;
    const html=rankedHtml[i++];
    if(!html){child.remove();return;}
    const tpl=document.createElement('template');tpl.innerHTML=html.trim();
    child.replaceWith(tpl.content.firstElementChild);
  });
  while(i<rankedHtml.length){
    const tpl=document.createElement('template');tpl.innerHTML=rankedHtml[i++].trim();
    out.appendChild(tpl.content.firstElementChild);
  }
  out.setAttribute('motion-reduced','');
  return out;
}
async function renderOrderPage(root,membership,orderedHandles,state){
  const sid=membership.sectionId;
  const base=new URL(membership.baseUrl);
  const currentPage=pageFromUrl();
  const sourceDoc=await fetchDoc(withSection(base,sid,currentPage));
  const freshContainer=sourceDoc.getElementById('ProductGridContainer');
  const sourceMotion=freshContainer?.querySelector('motion-list');
  const live=document.getElementById('ProductGridContainer');
  if(!freshContainer||!sourceMotion||!live) throw new Error('R9_PRODUCT_GRID_CONTAINER_MISSING');

  const pageSize=membership.firstPageProductCount||productCardsFromDoc(sourceDoc).length||orderedHandles.length;
  const start=(currentPage-1)*pageSize;
  const pageHandles=orderedHandles.slice(start,start+pageSize);
  const html=pageHandles.map(h=>membership.cardsByHandle.get(h)).filter(Boolean);
  const rankedMotion=buildRankedMotionList(sourceMotion,html);
  sourceMotion.replaceWith(rankedMotion);
  rewritePaginationLinks(freshContainer,state);
  live.innerHTML=freshContainer.innerHTML;
  updateSortUiFromDoc(sourceDoc);
  window.CANFOTO_R7_COLLECTION_READ_MODEL?.refresh?.('R9_FULL_SURFACE_RENDER');
  window.dispatchEvent(new CustomEvent('canfoto:r9-visible-ranking-rendered',{detail:{page:currentPage,pageHandles}}));
  return pageHandles;
}
async function restoreSourcePage(root,{preserveNoraUrl=false}={}){
  const membership=await getFullMembership(root);
  const currentPage=pageFromUrl();
  const doc=await fetchDoc(withSection(new URL(membership.baseUrl),membership.sectionId,currentPage));
  const fresh=doc.getElementById('ProductGridContainer');
  const live=document.getElementById('ProductGridContainer');
  if(!fresh||!live) throw new Error('R9_SOURCE_RESTORE_CONTAINER_MISSING');
  live.innerHTML=fresh.innerHTML;
  updateSortUiFromDoc(doc);
  if(preserveNoraUrl) rewritePaginationLinks(live,{parentKey:root.dataset.cfNoraUrlParent||'',childKey:root.dataset.cfNoraUrlChild||''});
  window.CANFOTO_R7_COLLECTION_READ_MODEL?.refresh?.('R9_SOURCE_ORDER_RESTORE');
}

async function bootRoot(root){
  const cfg={
    surface:clean(root.dataset.cfNoraSurface),surfaceKind:clean(root.dataset.cfNoraSurfaceKind),
    engine:clean(root.dataset.cfNoraEngine).toUpperCase(),lane:clean(root.dataset.cfNoraLane),
    capability:clean(root.dataset.cfNoraCapability)||'FULL_R8',surfaceCount:Number(root.dataset.cfNoraSurfaceCount||0),
    currentType:clean(root.dataset.cfNoraCurrentType)
  };
  const state={
    parentKey:null,childKey:null,taxonomy:[],status:'BOOTING',busy:false,runId:0,
    fullMembershipCount:0,canonicalCount:0,projectedDualCount:0,scoredCount:0,noncanonicalCount:0,
    sourceOrderFingerprint:'',canonicalOrderFingerprint:'',finalOrderFingerprint:'',
    sourceOwner:'',tailOrderPreserved:null,resetSourceOrderExact:null,capabilityAudit:null,
    lastFinalOrder:[],lastSourceOrder:[],lastRenderedPage:[],presentationRankByHandle:new Map(),lastReason:'BOOT'
  };
  let adapter=null;
  let dualProjector=null;
  document.documentElement.dataset.cfNoraR9Active='1';
  root.dataset.cfNoraVisibleRanking='OFF';
  root.dataset.cfNoraLanguageVersion=COPY_VERSION;
  document.documentElement.dataset.cfNoraP120hWeb='1';

  const started=performance.now();
  while(performance.now()-started<20000){
    adapter=window.CANFOTO_R8_COLLECTION_RANKING_ADAPTER||null;
    if(adapter?.getState?.().status==='READY') break;
    await sleep(50);
  }
  if(!adapter||adapter.getState?.().status!=='READY') throw new Error('R9_R8_ADAPTER_NOT_READY');
  if(['C2','C4','T2','T4','T6','T8'].includes(cfg.surface)){
    const pStarted=performance.now();
    while(performance.now()-pStarted<20000){dualProjector=window.CANFOTO_LB25_DUAL_SET_PURPOSE_PROJECTION||null;if(dualProjector?.getState?.().status==='READY')break;await sleep(50);}
    if(!dualProjector||dualProjector.getState?.().status!=='READY') throw new Error('R9_LB25_DUAL_PROJECTOR_NOT_READY');
    root.dataset.cfNoraLb25DualProjection='ON';
  }else{root.dataset.cfNoraLb25DualProjection='OFF';}
  if(cfg.surfaceKind==='PRODUCT_TYPE'){
    if(location.pathname!=='/collections/types') throw new Error('R9_PRODUCT_TYPE_PATH_MISMATCH');
    const q=clean(new URL(location.href).searchParams.get('q'));
    if(!cfg.currentType||q!==cfg.currentType) throw new Error('R9_PRODUCT_TYPE_Q_CURRENT_TYPE_MISMATCH');
    if(cfg.capability!==( ['T1','T2','T3','T4'].includes(cfg.surface)?'BICOLOR_ONLY_V1':'FULL_R8')) throw new Error('R803_PRODUCT_TYPE_CAPABILITY_MISMATCH');
    if(!['T1','T2','T3','T4','T5','T6','T7','T8'].includes(cfg.surface)) throw new Error('R803_PRODUCT_TYPE_SURFACE_UNSUPPORTED');
  }
  const sourceTaxonomy=cfg.engine==='PANEL'?buildPanelTaxonomy():cfg.engine==='COB'?buildCobTaxonomy():[];
  if(!sourceTaxonomy.length) throw new Error('R9_TAXONOMY_EMPTY');
  const capabilityResult=applyCapabilityPolicy(cfg.engine,sourceTaxonomy,cfg.capability);
  state.taxonomy=capabilityResult.taxonomy;state.capabilityAudit=capabilityResult.audit;
  state.status='READY';root.dataset.cfNoraPolicyStatus='PASS';

  const purposeHost=root.querySelector('[data-cf-nora-popover="purpose"]');
  const subHost=root.querySelector('[data-cf-nora-popover="sub"]');
  const purposeLabel=root.querySelector('[data-cf-nora-purpose-label]');
  const subLabel=root.querySelector('[data-cf-nora-sub-label]');
  const summary=root.querySelector('[data-cf-nora-summary]');
  const summaryHelp=root.querySelector('[data-cf-nora-summary-help]');
  const result=root.querySelector('[data-cf-nora-result]');
  const status=root.querySelector('[data-cf-nora-status]');

  function selectedParent(){return state.taxonomy.find(x=>x.key===state.parentKey)||null;}
  function selectedChild(){return selectedParent()?.children.find(x=>x.key===state.childKey)||null;}
  function validSelection(parent,child){
    const p=state.taxonomy.find(x=>x.key===parent);return !!(p&&p.children.some(x=>x.key===child));
  }
  function clearScores(){
    all(document,'.cf-unified-product-card[data-cf-ucard-handle]').forEach(card=>{
      const slot=card.querySelector('[data-cf-nora-score-slot]');
      if(slot){slot.hidden=true;slot.textContent='';slot.setAttribute('aria-hidden','true');slot.removeAttribute('aria-label');slot.removeAttribute('title');slot.dataset.cfNoraScoreRank='';slot.dataset.cfNoraScoreLen='';slot.dataset.cfNoraScoreRaw='';}
      card.classList.remove('cf-nora-score-visible');card.removeAttribute('data-cf-nora-purpose-rank');
    });
  }
  // CANFOTO COLLECTION CANONICAL FEED V1 — read-only, no theme-side scoring.
  // A full verified feed is authoritative for BOTH ordering and card labels;
  // otherwise sealed R8/LB25 fallback remains unchanged.
  const canonicalLiveRows=new Map();
  let canonicalLiveKey='';
  // Taxonomy child keys may already include the parent; never prefix twice.
  function canonicalSelectionKey(){
    const parent=clean(state.parentKey),child=clean(state.childKey);
    if(!parent||!child)return '';
    if(cfg.engine==='COB')return child; // COB V5 keys are native purposeKey, not parent::purposeKey.
    return child.startsWith(parent+'::')?child:parent+'::'+child;
  }
  // R755D: A dual set inherits only its explicitly mapped same-head SINGLE_READY_SET
  // anchor's VERIFIED FULL-feed purpose score. No BARE fallback or score invention.
  function livePanelDualProjection(handle){
    if(cfg.engine!=='PANEL'||cfg.lane!=='SINGLE_READY_SET'||
       !['C4','T4','T8'].includes(cfg.surface)||!canonicalLiveRows.size||
       canonicalLiveKey!==canonicalSelectionKey()||!dualProjector)return null;
    const h=clean(handle),e=dualProjector.getProjection?.(h);
    if(!e||e.engine!=='PANEL'||Number(e.lightUnitCount)!==2||
       e.anchorLane!=='SINGLE_READY_SET'||e.anchorPolicy!=='EXACT_CANONICAL_SAME_HEAD_SINGLE_READY_SET_ONLY')return null;
    const anchors=Array.isArray(e.singleAnchorHandles)?e.singleAnchorHandles.map(clean).filter(Boolean):[];
    if(!anchors.length||!anchors.includes(clean(e.anchorHandle)))return null;
    const anchor=canonicalLiveRows.get(clean(e.anchorHandle));
    if(!anchor||!Number.isFinite(Number(anchor.purposeScore)))return null;
    return {productHandle:h,rank:null,purposeScore:Number(anchor.purposeScore),
      projectionKind:'DOUBLE_READY_SET',projectedFromHandle:clean(e.anchorHandle),
      projectedFromLane:'SINGLE_READY_SET',scoreOwner:'VERIFIED_LIVE_FULL_SINGLE_READY_SET_ANCHOR',
      lightUnitCount:2};
  }

  // R756M — COB two-light products inherit *only* the same head family's
  // CURRENT FULL SINGLE_READY_SET canonical purpose score. No new scores,
  // no BARE fallback, no scoring/engine pool changes, no 3+ light packages.
  // Additional identities are exact catalog-verified single-set pairs where
  // the sealed LB2.5 map intentionally has no anchor. RUN21 still decides
  // whether that single-set anchor is eligible for the chosen purpose.
  const cobAdditionalVerifiedSetAnchors=new Map([
    ["gdx-exc-180rgb-ii-rgb-led-video-isigi-2li-full-set-60x90-softbox-260-cm-kalin-isik-ayagi","gdx-exc-180rgb-ii-rgb-led-video-isigi-full-set-60x90-softbox-260-cm-kalin-isik-ayagi"],
    ["gdx-exc-180rgb-ii-rgb-led-video-isigi-2li-full-set-gridli-120cm-octagon-260-cm-kalin-isik-ayagi","gdx-exc-180rgb-ii-rgb-led-video-isigi-full-set-gridli-120cm-octagon-260-cm-kalin-isik-ayagi"],
    ["gdx-exc-180rgb-ii-rgb-led-video-isigi-2li-full-set-gridli-60x90-softbox-260-cm-kalin-isik-ayagi","gdx-exc-180rgb-ii-rgb-led-video-isigi-full-set-gridli-60x90-softbox-260-cm-kalin-isik-ayagi"],
    ["gdx-ml60rgb-tasinabilir-video-rgb-led-i̇kili-isik-seti","gdx-ml60rgb-60w-rgb-bataryali-led-tekli-set-60x90-gridli-softbox-2-6m-isik-ayakli"],
  ]);
  // R756N: two exact export-verified COB families absent from sealed LB2.5 map.
  // The canonical single must still exist IN THE CURRENT FULL COB SET feed.
  // No inferred score and no BARE fallback; do not mutate LB2.5 or COB V5.
  const cobMissingLb25ExactPairs=new Map([
    // R803: exact same-family two-light SKU + current one-light SKU; inherit CURRENT FULL only.
    ["gdx-ml-100r-ii-100w-ikili-tasinabilir-rgb-bi-color-cob-led-video-isigi-seti-2700k-6500k-7350-lm-type-c-pd-100w-dc-girisli-bluetooth-uygulama-kontrollu","gdx-ml-100r-ii-100w-tekli-tasinabilir-rgb-bi-color-cob-led-video-isigi-seti-2700k-6500k-7350-lm-type-c-pd-100w-dc-girisli-bluetooth-uygulama-kontrollu"],
    ["gdx-hue-300r-ikili-dolgu-isigi-rgb-cob-led-seti","gdx-hue-300r-tekli-dolgu-isigi-rgb-cob-led-seti"],
    ["godox-la300r-k1-ikili-300w-full-rgb-bi-color-profesyonel-studyo-video-isigi-kiti","godox-la300r-k1-tekli-300w-full-rgb-bi-color-profesyonel-studyo-video-isigi-kiti"],
    ["gdx-exc-800c-ii-video-ve-fotograf-ikili-surekli-isik-set","gdx-exc-800c-ii-video-ve-fotograf-tekli-surekli-isik-set"],
    ["gdx-ed-300c-ii-video-ve-fotograf-surekli-ikili-isik-seti","gdx-ed-300c-ii-video-ve-fotograf-surekli-tekli-isik-seti"],
  ]);
  function liveCobDualProjection(handle){
    if(cfg.engine!=='COB'||cfg.lane!=='SINGLE_READY_SET'||
       !['C2','T2','T6'].includes(cfg.surface)||!dualProjector||
       canonicalLiveKey!==canonicalSelectionKey()||!canonicalLiveRows.size)return null;
    const h=clean(handle);
    if(canonicalLiveRows.has(h))return null; // never replace a canonical product
    const evidence=dualProjector.getProjection?.(h);
    if(!evidence){
      // Exact same-head single/dual pair attested in Shopify product export;
      // only LIVE COB FULL SINGLE_READY_SET ranked rows can supply its score.
      const exactAnchor=clean(cobMissingLb25ExactPairs.get(h));
      if(!exactAnchor||exactAnchor===h)return null;
      const actual=canonicalLiveRows.get(exactAnchor);
      if(!actual||!Number.isFinite(Number(actual.purposeScore))||
         !clean(actual.headFamilyKey)||!Number.isInteger(Number(actual.rank))||
         Number(actual.rank)<1)return null;
      return {productHandle:h,rank:null,purposeScore:Number(actual.purposeScore),
        projectionKind:'DOUBLE_READY_SET',projectedFromHandle:exactAnchor,
        projectedFromLane:'SINGLE_READY_SET',sourceCanonicalRank:Number(actual.rank),
        scoreOwner:'R756N_EXPORT_VERIFIED_EXACT_HEAD_CURRENT_COB_SET_FULL',
        headFamilyKey:clean(actual.headFamilyKey),lightUnitCount:2};
    }
    if(evidence.engine!=='COB'||Number(evidence.lightUnitCount)!==2||
       evidence.anchorLane!=='SINGLE_READY_SET'||
       evidence.anchorPolicy!=='EXACT_CANONICAL_SAME_HEAD_SINGLE_READY_SET_ONLY')return null;
    const mappedAnchor=clean(evidence.anchorHandle);
    const explicitAnchors=Array.isArray(evidence.singleAnchorHandles)?
      evidence.singleAnchorHandles.map(clean).filter(Boolean):[];
    let anchorHandle='';
    if(mappedAnchor&&explicitAnchors.includes(mappedAnchor))anchorHandle=mappedAnchor;
    else if(!mappedAnchor&&!explicitAnchors.length)anchorHandle=clean(cobAdditionalVerifiedSetAnchors.get(h));
    if(!anchorHandle||anchorHandle===h)return null;
    const anchor=canonicalLiveRows.get(anchorHandle);
    if(!anchor||!Number.isFinite(Number(anchor.purposeScore))||
       !clean(anchor.headFamilyKey)||
       clean(anchor.headFamilyKey)!==clean(evidence.headFamilyKey))return null;
    // The confirmed anchor comes from the current RUN FULL COB SET feed,
    // never the frozen R8 snapshot or an unrelated same-brand product.
    return {productHandle:h,rank:null,purposeScore:Number(anchor.purposeScore),
      projectionKind:'DOUBLE_READY_SET',projectedFromHandle:anchorHandle,
      projectedFromLane:'SINGLE_READY_SET',
      scoreOwner:'VERIFIED_CURRENT_COB_FULL_SINGLE_READY_SET_ANCHOR',
      sourceCanonicalRank:Number(anchor.rank),headFamilyKey:clean(anchor.headFamilyKey),lightUnitCount:2};
  }
  function cobSetOrderWithVerifiedTwins(source,base){
    const allowed=new Set(source.map(clean));
    const twins=source.map(h=>liveCobDualProjection(h)).filter(Boolean)
      .filter(row=>allowed.has(row.productHandle));
    if(!twins.length)return base; // exact native feed order with no projected rows
    const blocks=base.map((row,i)=>({canonicalRank:Number(row.rank),
      initial:i,anchorHandle:row.productHandle,rows:[row]}));
    const byAnchor=new Map(blocks.map(block=>[block.anchorHandle,block]));
    for(let i=0;i<twins.length;i++){
      const row=twins[i],linked=byAnchor.get(row.projectedFromHandle);
      if(linked){linked.rows.push(row);continue;}
      // If the scored single is not displayed in this product collection,
      // place its two-light presentation row at the native single's rank.
      // Never move/recompute the canonical ranked singles themselves.
      blocks.push({canonicalRank:Number(row.sourceCanonicalRank),
        initial:base.length+i,anchorHandle:row.projectedFromHandle,rows:[row]});
    }
    blocks.sort((a,b)=>a.canonicalRank-b.canonicalRank||a.initial-b.initial);
    return blocks.flatMap(b=>b.rows);
  }
  // R755K: Export-verified same-head product pairs. Do not alter LB2.5.
  // P300TS 100C II 100W SINGLE_READY_SET live anchor is proven by physical QA.
  const additionalExactSetAnchors=new Map([
    ['gdx-p300ts-100c-ii-bicolor-100w-led-panel-paslanmaz-celik-kalin-isik-ayagi-ikili-studyo-seti-2-isik-2-ayak','gdx-p300ts-100c-ii-bicolor-100w-led-panel-kalin-isik-ayagi-tekli-studyo-seti'],
    // R792: exact product-SKU / 1-head-to-2-head evidence verified from public product descriptions.
    // This is ONLY a view projection; absent current FULL SINGLE_READY_SET anchor => NO SCORE.
    ['gdx-pl900c-ii-ikili-60w-bi-color-led-studyo-panel-isigi-beyaz-govde','gdx-pl900c-ii-tekli-60w-bi-color-led-studyo-panel-isigi-beyaz-govde'],
    ['gdx-pl500c-ii-ikili-set-bi-color-tasinabilir-led-video-panel-isigi-2700k-6500k-500-led-8-fx-sahne-efekti-dc-ve-batarya-destekli','gdx-pl500c-ii-tekli-set-bi-color-tasinabilir-led-video-panel-isigi-2700k-6500k-500-led-8-fx-sahne-efekti-dc-ve-batarya-destekli'],
    ['gdx-sft-320c-ii-ikili-32cm-bi-color-masaustu-led-soft-panel-canli-yayin-isigi','gdx-sft-320c-ii-32cm-bi-color-masaustu-led-soft-panel-canli-yayin-isigi'],
  ]);
  // PL700C II: render-only projection from CURRENT RUN FULL BARE source,
  // never a fabricated SINGLE_READY_SET canonical membership.
  const additionalBareSingleHeads=new Map([
    ['gdx-pl700c-ii-35w-4-kanat-tekli-barndoorlu-bi-color-led-video-paneli-2700k-6500k-720-led-8-fx-efekt-ac-dc-cift-guclu','gdx-pl700c-ii-35w-4-kanat-barndoorlu-bi-color-led-video-paneli-2700k-6500k-720-led-8-fx-efekt-ac-dc-cift-guclu'],
  ]);
  function additionalExactSetDualProjection(handle){
    if(cfg.engine!=='PANEL'||cfg.lane!=='SINGLE_READY_SET'||!['C4','T4','T8'].includes(cfg.surface)||
       canonicalLiveKey!==canonicalSelectionKey()||!canonicalLiveRows.size)return null;
    const h=clean(handle),head=additionalExactSetAnchors.get(h);
    if(!head||canonicalLiveRows.has(h))return null;
    const anchor=canonicalLiveRows.get(head);
    if(!anchor||!Number.isFinite(Number(anchor.purposeScore)))return null;
    return {productHandle:h,rank:null,purposeScore:Number(anchor.purposeScore),
      projectionKind:'DOUBLE_READY_SET',projectedFromHandle:head,
      projectedFromLane:'SINGLE_READY_SET',scoreOwner:'CURRENT_FULL_SET_VERIFIED_EXACT_MODEL_R755K',lightUnitCount:2};
  }
  function additionalBareSingleProjection(handle){
    if(cfg.engine!=='PANEL'||cfg.lane!=='SINGLE_READY_SET'||!['C4','T4','T8'].includes(cfg.surface)||
       bareHeadKey!==canonicalSelectionKey()||!canonicalLiveRows.size)return null;
    const h=clean(handle),head=additionalBareSingleHeads.get(h);
    if(!head||canonicalLiveRows.has(h))return null;
    const row=bareHeadRows.get(head);
    if(!row||!Number.isFinite(Number(row.purposeScore)))return null;
    return {productHandle:h,rank:null,purposeScore:Number(row.purposeScore),
      projectionKind:'SINGLE_BARE_HEAD_PRESENTATION',projectedFromHandle:head,
      projectedFromLane:'BARE_LIGHT',scoreOwner:'CURRENT_FULL_BARE_HEAD_PRESENTATION_ONLY',sourceRunId:bareHeadRunId,lightUnitCount:1};
  }
  // R755J: Explicit BARE_HEAD_TO_DUAL_PRESENTATION projection. This is NOT
  // SINGLE_READY_SET canonical membership and does not alter LB2.5 or RUN20.
  // Every source score MUST be fetched from an actual current FULL BARE feed.
  const verifiedBareDualHeads=new Map([
    ["gdx-pro-led-228as-bataryali-2li-surekli-led-isik-seti","gdx-pro-led-228as-bataryali-surekli-led-isik"],
    ["gdx-cf-300c-bicolor-mobil-2li-surekli-video-panel-led-isik-seti","gdx-cf-300c-bicolor-led-video-isigi"],
    ["gdx-cf-led-1700w-2li-video-led-isigi","gdx-cf-led-1700w-video-led-isigi"],
    ["gdx-cf-led-900w-2li-video-led-isigi","gdx-cf-led-900w-video-led-isigi"],
    ["gdx-cf-led-2020c-2li-surekli-panel-led-isik-seti","gdx-cf-led-2020c-video-led-isik"],
    ["gdx-cf-led-600rgb-2li-surekli-panel-led-isik-seti","gdx-cf-led-600rgb-video-led-isik"],
    ['gdx-pl700c-ii-35w-4-kanat-ikili-barndoorlu-bi-color-led-video-paneli-2700k-6500k-720-led-8-fx-efekt-ac-dc-cift-guclu','gdx-pl700c-ii-35w-4-kanat-barndoorlu-bi-color-led-video-paneli-2700k-6500k-720-led-8-fx-efekt-ac-dc-cift-guclu'],
  ]);
  let bareHeadRows=new Map(),bareHeadKey='',bareHeadRunId=null;
  function liveBareHeadDualProjection(handle){
    if(cfg.engine!=='PANEL'||cfg.lane!=='SINGLE_READY_SET'||!['C4','T4','T8'].includes(cfg.surface)||
       bareHeadKey!==canonicalSelectionKey()||!canonicalLiveRows.size)return null;
    const h=clean(handle),head=verifiedBareDualHeads.get(h);
    if(!head||canonicalLiveRows.has(h)||livePanelDualProjection(h))return null;
    const row=bareHeadRows.get(head);
    if(!row||!Number.isFinite(Number(row.purposeScore)))return null;
    return {productHandle:h,rank:null,purposeScore:Number(row.purposeScore),
      projectionKind:'DOUBLE_BARE_HEAD_PRESENTATION',projectedFromHandle:head,
      projectedFromLane:'BARE_LIGHT',scoreOwner:'CURRENT_FULL_BARE_HEAD_PRESENTATION_ONLY',
      sourceRunId:bareHeadRunId,lightUnitCount:2};
  }
  async function loadBareHeadPresentation(selectionKey){
    bareHeadRows=new Map();bareHeadKey='';bareHeadRunId=null;
    if(cfg.engine!=='PANEL'||cfg.lane!=='SINGLE_READY_SET'||!['C4','T4','T8'].includes(cfg.surface)||
       canonicalLiveKey!==selectionKey||!canonicalLiveRows.size)return;
    const url=new URL('https://amv2.canfoto.com/public/v66c/selection-projection');
    url.searchParams.set('engine','GDX_PANEL_LED_V4');
    url.searchParams.set('lane','BARE_LIGHT');url.searchParams.set('selectionKey',selectionKey);
    const ctrl=new AbortController(),timer=setTimeout(()=>ctrl.abort(),5000);
    try{
      const res=await fetch(url.toString(),{mode:'cors',credentials:'omit',cache:'no-store',signal:ctrl.signal});
      if(!res.ok)return;
      const data=await res.json();
      if(data?.ok!==true||data.engineOwner!=='GDX_PANEL_LED_V4'||data.lane!=='BARE_LIGHT'||
         data.selectionKey!==selectionKey||data.fullRankedAvailable!==true||
         data.projectionKind!=='FULL_CANONICAL_NATIVE_SELECTION_RANKED_POOL'||
         !Number.isInteger(data.runId)||data.runId<13||!root.dataset.cfNoraCanonicalFeed.endsWith('_RUN_'+data.runId))return;
      const rows=data?.projection?.ranked;
      if(!Array.isArray(rows)||!rows.length||rows.length>500)return;
      const verified=new Map(),seen=new Set();
      for(let i=0;i<rows.length;i++){
        const r=rows[i],h=clean(r?.handle||r?.productHandle),score=Number(r?.purposeScore100);
        if(!h||seen.has(h)||Number(r?.rank)!==i+1||clean(r?.lane)!=='BARE_LIGHT'||
           !Number.isFinite(score)||score<0||score>100)return;
        seen.add(h);verified.set(h,{purposeScore:score});
      }
      bareHeadRows=verified;bareHeadKey=selectionKey;bareHeadRunId=data.runId;
      root.dataset.cfNoraBareHeadProjection='CURRENT_FULL_BARE_RUN_'+data.runId;
    }catch(_){return;}finally{clearTimeout(timer);}
  }
  // R755G: RGB-only purpose gate based on verified RGB-family handles from
  // the sealed PANEL R8 snapshot. No modification to sealed scores or Worker.
  // Unknown products are intentionally UNRANKED, not assigned an invented score.
  const verifiedRgbHandles=new Set([
    "gdx-cf-1000r-rgb-led-video-isigi",
    "gdx-cf-1000r-rgb-led-video-isik-seti",
    "gdx-cf-1500r-rgb-led-video-isigi",
    "gdx-cf-1500r-rgb-led-video-isik-seti",
    "gdx-cf-900r-rgb-led-video-isigi-tekli-seti-14-efektli-45w-35w-260cm-ayakli-set",
    "gdx-cf-led-600r-rgb-led-video-isik-seti",
    "gdx-cf-led-600rgb-video-led-isik",
    "gdx-p-750r-ii-150w-rgb-youtube-ve-vlog-produksiyon-isik-seti",
    "gdx-p-750r-ii-rgbwy-canli-yayin-ve-podcast-video-isik-sistemi",
    "godox-ldx50r-rgbww-profesyonel-led-panel-aydinlatma"
  ]);
  function rgbOnlySelection(){
    return cfg.engine==='PANEL'&&state.parentKey==='rgb_creative_video';
  }
  function isVerifiedRgbHandle(handle){
    const h=clean(handle);
    if(verifiedRgbHandles.has(h))return true;
    if(cfg.lane!=='SINGLE_READY_SET')return false;
    const bareHead=verifiedBareDualHeads.get(h);
    if(bareHead)return verifiedRgbHandles.has(bareHead);
    if(!dualProjector)return false;
    const dual=dualProjector.getProjection?.(h);
    return !!dual&&dual.engine==='PANEL'&&dual.lightUnitCount===2&&
      dual.anchorLane==='SINGLE_READY_SET'&&
      dual.anchorPolicy==='EXACT_CANONICAL_SAME_HEAD_SINGLE_READY_SET_ONLY'&&
      verifiedRgbHandles.has(clean(dual.anchorHandle))&&
      Array.isArray(dual.singleAnchorHandles)&&dual.singleAnchorHandles.map(clean).includes(clean(dual.anchorHandle));
  }
  function rgbEligible(handle){
    return !rgbOnlySelection()||isVerifiedRgbHandle(handle);
  }
  function purposeRowForHandle(handle){
    if(!rgbEligible(handle))return null;
    if(canonicalLiveKey===(canonicalSelectionKey())&&canonicalLiveRows.size)
      return canonicalLiveRows.get(clean(handle))||liveCobDualProjection(handle)||livePanelDualProjection(handle)||additionalExactSetDualProjection(handle)||additionalBareSingleProjection(handle)||liveBareHeadDualProjection(handle)||null;
    if(dualProjector&&['C2','C4','T2','T4','T6','T8'].includes(cfg.surface))
      return dualProjector.getProductPurposeRank(cfg.engine,state.childKey,handle,{lane:cfg.lane,surface:cfg.surface});
    return adapter.getProductPurposeRank(cfg.engine,state.childKey,handle,{lane:cfg.lane});
  }
  function purposeOrderForSource(source){
    // RGB-only selections must never rank non-certified Bi-Color handles.
    if(canonicalLiveKey===(canonicalSelectionKey())&&canonicalLiveRows.size){
      const allowed=new Set(source.map(clean));
      const base=[...canonicalLiveRows.values()].filter(r=>allowed.has(r.productHandle)&&rgbEligible(r.productHandle));
      if(cfg.engine==='COB'&&cfg.lane==='SINGLE_READY_SET'&&['C2','T2','T6'].includes(cfg.surface))
        return cobSetOrderWithVerifiedTwins(source,base);
      if(cfg.engine!=='PANEL'||cfg.lane!=='SINGLE_READY_SET'||!['C4','T4','T8'].includes(cfg.surface))return base;
      const extraSingles=source.filter(rgbEligible).map(h=>additionalBareSingleProjection(h)).filter(Boolean)
        .filter(r=>!canonicalLiveRows.has(r.productHandle));
      const duals=source.filter(rgbEligible).map(h=>livePanelDualProjection(h)||additionalExactSetDualProjection(h)||liveBareHeadDualProjection(h)).filter(Boolean)
        .filter(r=>!canonicalLiveRows.has(r.productHandle));
      // R755F: Group by verified anchor score, not upstream rank. Keep each proven
      // two-light twin directly after its single-light anchor. Equal scores preserve
      // the canonical feed order. Missing/unverified twins remain unscored tail.
      const groups=[...base,...extraSingles].map((anchor,index)=>({
        anchor,index,score:Number(anchor.purposeScore),twins:[]
      }));
      const byHandle=new Map(groups.map(group=>[group.anchor.productHandle,group]));
      const unmatched=[];
      for(const dual of duals){
        const group=byHandle.get(dual.projectedFromHandle);
        if(group)group.twins.push(dual);
        else unmatched.push(dual); // Verified feed anchor can be outside this collection.
      }
      groups.sort((a,b)=>b.score-a.score||a.index-b.index);
      // Verified orphan twins also participate in descending score order; their
      // exact score is inherited from a verified live SINGLE_READY_SET anchor.
      const blocks=groups.map(group=>({score:group.score,index:group.index,rows:[group.anchor,...group.twins]}));
      unmatched.forEach((dual,index)=>blocks.push({
        score:Number(dual.purposeScore),index:base.length+index,rows:[dual]
      }));
      blocks.sort((a,b)=>b.score-a.score||a.index-b.index);
      return blocks.flatMap(block=>block.rows);
    }
    if(dualProjector&&['C2','C4','T2','T4','T6','T8'].includes(cfg.surface))
      return dualProjector.getPurposeOrder(cfg.engine,state.childKey,{lane:cfg.lane,handles:source.filter(rgbEligible),surface:cfg.surface}).filter(r=>rgbEligible(r.productHandle));
    return adapter.getPurposeOrder(cfg.engine,state.childKey,{lane:cfg.lane,handles:source.filter(rgbEligible)}).filter(r=>rgbEligible(r.productHandle));
  }
  // No score is synthesized. In particular Top3 must NEVER represent full ranking.
  // API may refuse some lanes; fallback must not mix partial live and old rows.
  async function loadValidatedCanonicalFeed(selectionKey){
    canonicalLiveRows.clear();canonicalLiveKey='';
    root.dataset.cfNoraCanonicalFeed='FROZEN_FALLBACK';
    const key=clean(selectionKey),engine=cfg.engine==='PANEL'?'GDX_PANEL_LED_V4':cfg.engine==='COB'?'GDX_COB_LED_V5':'';
    if(!engine||!['BARE_LIGHT','SINGLE_READY_SET'].includes(cfg.lane)||! /^[a-z0-9_:-]{1,128}$/i.test(key))return null;
    const endpoint=new URL('https://amv2.canfoto.com/public/v66c/selection-projection');
    endpoint.searchParams.set('engine',engine);endpoint.searchParams.set('lane',cfg.lane);endpoint.searchParams.set('selectionKey',key);
    const ctrl=new AbortController(),timer=setTimeout(()=>ctrl.abort(),5000);
    try{
      const res=await fetch(endpoint.toString(),{signal:ctrl.signal,mode:'cors',cache:'no-store',credentials:'omit'});
      if(!res.ok)return null;
      const data=await res.json();
      if(data?.ok!==true||data.engineOwner!==engine||data.lane!==cfg.lane||data.selectionKey!==key||
         !((engine==='GDX_PANEL_LED_V4'&&data.projectionKind==='FULL_CANONICAL_NATIVE_SELECTION_RANKED_POOL')||data.projectionKind==='FULL_CANONICAL_RANKED_POOL')||data.fullRankedAvailable!==true||
         !Number.isInteger(data.runId)||data.runId<13)return null;
      const rows=data?.projection?.ranked;
      if(!Array.isArray(rows)||!rows.length||rows.length>500)return null;
      const seen=new Set(),mapped=[];
      for(let i=0;i<rows.length;i++){
        const r=rows[i],handle=clean(r?.handle||r?.productHandle),score=Number(r?.purposeScore100);
        if(!handle||seen.has(handle)||Number(r?.rank)!==i+1||!Number.isFinite(score)||
           score<0||score>100||clean(r?.lane)!==cfg.lane)return null;
        seen.add(handle);
        mapped.push({productHandle:handle,rank:i+1,purposeScore:score,
          headFamilyKey:cfg.engine==='COB'?clean(r?.headFamilyKey):'',
          projectionKind:'VALIDATED_CANONICAL_FULL_POOL'});
      }
      mapped.forEach(r=>canonicalLiveRows.set(r.productHandle,r));canonicalLiveKey=key;
      root.dataset.cfNoraCanonicalFeed='VALIDATED_'+cfg.engine+'_'+cfg.lane+'_RUN_'+data.runId;
      return mapped;
    }catch(_){return null;}finally{clearTimeout(timer);}
  }
  function applyScores(){
    clearScores();if(!state.childKey) return {shown:0,missing:0};
    let shown=0,missing=0;
    all(document,'.cf-unified-product-card[data-cf-ucard-handle]').forEach(card=>{
      const handle=clean(card.dataset.cfUcardHandle);const slot=card.querySelector('[data-cf-nora-score-slot]');if(!slot)return;
      const row=purposeRowForHandle(handle);
      const display=row?displayScore(row.purposeScore):'';const raw=row?rawScore(row.purposeScore):'';
      if(!row||!display){missing++;return;}
      slot.textContent=display;slot.hidden=false;slot.setAttribute('aria-hidden','false');
      slot.setAttribute('aria-label',`Amaç Uyumu: ${display}/100`);slot.setAttribute('title',`Amaç Uyumu: ${display}/100`);
      slot.dataset.cfNoraScoreRaw=raw;slot.dataset.cfNoraScoreLen=String(display.length);
      const presentationRank=Number(state.presentationRankByHandle.get(handle)||0);const rank=presentationRank||Number(row.rank);
      slot.dataset.cfNoraScoreRank=presentationRank>=1&&presentationRank<=3?String(presentationRank):'';
      card.dataset.cfNoraPurposeRank=String(rank);card.dataset.cfNoraPresentationRank=presentationRank?String(presentationRank):'';card.classList.add('cf-nora-score-visible');shown++;
    });
    return {shown,missing};
  }
  function renderPurpose(){purposeHost.innerHTML='';state.taxonomy.forEach(p=>purposeHost.appendChild(makeChoice({key:p.key,label:p.label,parent:true,pressed:p.key===state.parentKey,description:parentDescription(cfg.engine,p.key,cfg.capability)})));}
  function renderSub(){
    subHost.innerHTML='';const p=selectedParent();
    if(!p){const x=document.createElement('span');x.className='cf-nora-r9__micro';x.textContent='Önce amaç seçin.';subHost.appendChild(x);return;}
    p.children.forEach(c=>subHost.appendChild(makeChoice({key:c.key,label:c.label,parent:false,pressed:c.key===state.childKey,description:childDescription(cfg.engine,c.key)})));
  }
  function renderUi(){
    const p=selectedParent(),c=selectedChild(),complete=!!(p&&c);
    purposeLabel.textContent=p?shortLabel(p.label):'Amaç seçin';
    subLabel.textContent=c?shortLabel(c.label):(p?'Alt amaç seçin':'Önce amaç seçin');
    summary.textContent=!p?'Amaç ve alt amaç seçin':complete?`${shortLabel(p.label)} → ${shortLabel(c.label)}`:`${shortLabel(p.label)} → Alt amaç seçin`;
    root.dataset.cfNoraState=complete?'COMPLETE':p?'PURPOSE_SELECTED':'EMPTY';
    renderPurpose();renderSub();setGuide(root,state);
    if(!complete) clearScores();
    const emptyCount=cfg.surfaceKind==='PRODUCT_TYPE'?`${cfg.surfaceCount} ürün bu ürün tipinde`:`${cfg.surfaceCount} ürün bu kategoride`;
    result.textContent=complete?(state.scoredCount?`${state.scoredCount} ürün seçiminize göre öne alındı`:'NORA sıralaması hazırlanıyor…'):emptyCount;
    if(summaryHelp) summaryHelp.textContent=complete?'NORA · Amaç Uyumu sıralaması aktif':p?'Alt amacı seçtiğinizde ürünler seçiminize göre sıralanır.':'NORA, seçiminize göre ürünleri değerlendirir.';
    if(complete) status.textContent='Skor, seçtiğiniz amaca teknik uyumu gösterir.';
    else if(p) status.textContent=parentDescription(cfg.engine,p.key,cfg.capability);
    else status.textContent=cfg.capability==='BICOLOR_ONLY_V1'?'Bu sayfada yalnız Bi-Color ürünlere uygun çekim amaçları gösterilir.':'Amaç seçerek NORA önerilerini daraltın.';
  }
  function writeUrl(mode='push',{resetPage=false}={}){
    const u=new URL(location.href);
    if(state.parentKey)u.searchParams.set(URL_PARENT,state.parentKey);else u.searchParams.delete(URL_PARENT);
    if(state.childKey)u.searchParams.set(URL_CHILD,state.childKey);else u.searchParams.delete(URL_CHILD);
    if(resetPage)u.searchParams.delete('page');
    const method=mode==='push'?'pushState':'replaceState';history[method]({},'',u.pathname+u.search+u.hash);
  }
  async function applyRanking(reason='COMPLETE'){
    if(!state.childKey) return;
    // R758 — same protective gate for 4 COB Collection/Product Type surfaces.
    // RUN21 full feed remains intact; this is NOT recomputed or relabelled.
    if(cfg.engine==='COB'&&['dental_closeup_documentation','procedure_technical_closeup'].includes(state.childKey)){
      await restoreSource('R758_CLINICAL_EVIDENCE_HOLD');
      if(state.childKey){
        const clinicalMsg='Bu klinik yakın çekim rolü için doğrulanmış ışık geometrisi ve yansıma/mesafe verisi bulunmadığından COB Amaç Uyumu skoru ve öneri sıralaması gösterilmiyor. Genel katalog sırası korunuyor.';
        root.dataset.cfNoraClinicalEvidenceGate='HOLD_NEAR_FIELD_UNVERIFIED';
        root.dataset.cfNoraVisibleRanking='OFF';
        status.textContent=clinicalMsg;
        result.textContent='Klinik amaç uygunluğu henüz doğrulanmadı';
        if(summaryHelp)summaryHelp.textContent=clinicalMsg;
      }
      return;
    }
    delete root.dataset.cfNoraClinicalEvidenceGate;
    const run=++state.runId;state.busy=true;state.lastReason=reason;setRankingBusy(root,true);
    try{
      const membership=await getFullMembership(root,{force:reason==='FILTER_RELOAD'});if(run!==state.runId)return;
      const source=membership.handles.slice();
      // One shared validated read serves both ordering and score labels.
      await loadValidatedCanonicalFeed(canonicalSelectionKey());if(run!==state.runId)return;
      await loadBareHeadPresentation(canonicalSelectionKey());if(run!==state.runId)return;
      const rankedRows=purposeOrderForSource(source);
      const ranked=rankedRows.map(x=>clean(x.productHandle));const rset=new Set(ranked);
      const tail=source.filter(h=>!rset.has(h));const finalOrder=ranked.concat(tail);
      const canonicalOnly=rankedRows.filter(x=>!['DOUBLE_READY_SET','DOUBLE_BARE_HEAD_PRESENTATION','SINGLE_BARE_HEAD_PRESENTATION'].includes(clean(x.projectionKind)));
      const projectedDual=rankedRows.filter(x=>['DOUBLE_READY_SET','DOUBLE_BARE_HEAD_PRESENTATION'].includes(clean(x.projectionKind)));
      const canonicalFp=await sha256Text(ranked.join('\n'));const finalFp=await sha256Text(finalOrder.join('\n'));
      state.fullMembershipCount=source.length;state.canonicalCount=canonicalOnly.length;state.projectedDualCount=projectedDual.length;state.scoredCount=ranked.length;state.noncanonicalCount=tail.length;
      state.sourceOrderFingerprint=membership.sourceOrderFingerprint;state.canonicalOrderFingerprint=canonicalFp;state.finalOrderFingerprint=finalFp;
      state.sourceOwner=membership.sourceOwner;state.tailOrderPreserved=sameOrder(tail,source.filter(h=>!rset.has(h)));
      state.lastSourceOrder=source.slice();state.lastFinalOrder=finalOrder.slice();state.presentationRankByHandle=new Map(ranked.map((h,i)=>[h,i+1]));
      root.dataset.cfNoraBareHeadProjectedCount=String(rankedRows.filter(x=>x.projectionKind==='DOUBLE_BARE_HEAD_PRESENTATION').length);
      root.dataset.cfNoraLb25ProjectedDualCount=String(state.projectedDualCount);root.dataset.cfNoraLb25ScoredCount=String(state.scoredCount);
      root.dataset.cfNoraVisibleRanking='ON';
      const pageHandles=await renderOrderPage(root,membership,finalOrder,state);if(run!==state.runId)return;
      state.lastRenderedPage=pageHandles.slice();applyScores();renderUi();
      root.dataset.cfNoraVisibleRanking='ON';root.dataset.cfNoraSourceOrderFingerprint=state.sourceOrderFingerprint;root.dataset.cfNoraFinalOrderFingerprint=state.finalOrderFingerprint;
    }finally{if(run===state.runId){state.busy=false;setRankingBusy(root,false);}}
  }
  async function restoreSource(reason='RESET'){
    const run=++state.runId;state.busy=true;state.lastReason=reason;setRankingBusy(root,true);
    try{
      await restoreSourcePage(root);if(run!==state.runId)return;
      clearScores();root.dataset.cfNoraVisibleRanking='OFF';
      const membership=await getFullMembership(root);state.lastSourceOrder=membership.handles.slice();state.fullMembershipCount=membership.handles.length;state.canonicalCount=0;state.projectedDualCount=0;state.scoredCount=0;state.sourceOrderFingerprint=membership.sourceOrderFingerprint;state.sourceOwner=membership.sourceOwner;state.presentationRankByHandle=new Map();const pageSize=membership.firstPageProductCount||membership.handles.length;const start=(pageFromUrl()-1)*pageSize;
      state.resetSourceOrderExact=sameOrder(fingerprintDomOrder(),membership.handles.slice(start,start+pageSize));
    }finally{if(run===state.runId){state.busy=false;setRankingBusy(root,false);renderUi();}}
  }
  async function chooseParent(key,{historyMode='push'}={}){
    if(!state.taxonomy.some(x=>x.key===key))return;
    state.parentKey=key;state.childKey=null;closePopovers(root);writeUrl(historyMode,{resetPage:true});renderUi();await restoreSource('PURPOSE_SELECTED');
  }
  async function chooseChild(key,{historyMode='push'}={}){
    const p=selectedParent();if(!p||!p.children.some(x=>x.key===key))return;
    state.childKey=key;closePopovers(root);writeUrl(historyMode,{resetPage:true});renderUi();await applyRanking('COMPLETE');
  }
  async function reset({historyMode='push',reason='RESET'}={}){
    state.parentKey=null;state.childKey=null;closePopovers(root);writeUrl(historyMode,{resetPage:true});renderUi();await restoreSource(reason);
  }
  async function restoreFromUrl(reason='URL_RESTORE'){
    const u=new URL(location.href);const p=clean(u.searchParams.get(URL_PARENT)),c=clean(u.searchParams.get(URL_CHILD));
    if(p&&c&&validSelection(p,c)){state.parentKey=p;state.childKey=c;renderUi();await applyRanking(reason);return;}
    if(p&&state.taxonomy.some(x=>x.key===p)){state.parentKey=p;state.childKey=null;renderUi();await restoreSource(reason);return;}
    state.parentKey=null;state.childKey=null;renderUi();await restoreSource(reason);
  }
  function exitForNativeSort(){
    if(!state.parentKey&&!state.childKey)return;
    state.runId++;state.parentKey=null;state.childKey=null;state.busy=false;setRankingBusy(root,false);clearScores();root.dataset.cfNoraVisibleRanking='OFF';writeUrl('replace',{resetPage:true});renderUi();status.textContent='Standart sıralama aktif.';
  }

  root.addEventListener('click',e=>{
    const choice=e.target.closest('[data-cf-nora-choice]');
    if(choice&&root.contains(choice)){choice.dataset.cfNoraChoice==='parent'?chooseParent(clean(choice.dataset.cfNoraKey)):chooseChild(clean(choice.dataset.cfNoraKey));return;}
    const action=e.target.closest('[data-cf-nora-action]');if(action&&root.contains(action)){if(action.dataset.cfNoraAction==='reset')reset();return;}
    const opener=e.target.closest('[data-cf-nora-opener]');
    if(opener&&root.contains(opener)){const kind=opener.dataset.cfNoraOpener;if(kind==='sub'&&!state.parentKey)return;const field=opener.closest('.cf-nora-r9__field');const open=!field.classList.contains('is-open');closePopovers(root);field.classList.toggle('is-open',open);opener.setAttribute('aria-expanded',String(open));}
  });
  document.addEventListener('click',e=>{if(!root.contains(e.target))closePopovers(root)});
  root.addEventListener('keydown',e=>{if(e.key==='Escape'){closePopovers(root);return;}if((e.key==='ArrowDown'||e.key==='ArrowUp')&&e.target.matches('.cf-nora-r9__choice')){const list=all(e.target.parentElement,'.cf-nora-r9__choice:not([disabled])');const i=list.indexOf(e.target);if(i>-1){e.preventDefault();list[(i+(e.key==='ArrowDown'?1:-1)+list.length)%list.length]?.focus();}}});
  document.addEventListener('change',e=>{if(e.target?.matches?.('input[name="sort_by"],select[name="sort_by"]'))exitForNativeSort();},true);
  document.addEventListener('collection:reloaded',async()=>{
    if(state.childKey){writeUrl('replace');await applyRanking('FILTER_RELOAD');}
    else{clearScores();root.dataset.cfNoraVisibleRanking='OFF';window.CANFOTO_R7_COLLECTION_READ_MODEL?.refresh?.('COLLECTION_RELOADED_NO_NORA');}
  });
  window.addEventListener('popstate',()=>setTimeout(()=>restoreFromUrl('POPSTATE'),0));

  const publicApi=Object.freeze({
    version:VERSION,
    getState:()=>Object.freeze({
      status:state.status,surface:cfg.surface,surfaceKind:cfg.surfaceKind,engine:cfg.engine,lane:cfg.lane,capability:cfg.capability,currentType:cfg.currentType,
      uiState:root.dataset.cfNoraState,parentKey:state.parentKey,childKey:state.childKey,
      parentCount:state.taxonomy.length,childCount:state.taxonomy.reduce((n,p)=>n+p.children.length,0),
      visibleRanking:root.dataset.cfNoraVisibleRanking,rankingMutation:state.childKey?'FULL_SURFACE_STABLE_PARTITION':'NONE',
      sourceOwner:state.sourceOwner,fullMembershipCount:state.fullMembershipCount,canonicalCount:state.canonicalCount,projectedDualCount:state.projectedDualCount,scoredCount:state.scoredCount,noncanonicalCount:state.noncanonicalCount,
      sourceOrderFingerprint:state.sourceOrderFingerprint,canonicalOrderFingerprint:state.canonicalOrderFingerprint,finalOrderFingerprint:state.finalOrderFingerprint,
      tailOrderPreserved:state.tailOrderPreserved,resetSourceOrderExact:state.resetSourceOrderExact,busy:state.busy,lastReason:state.lastReason,
      scorePresentation:'INTEGER_ROUNDED_FROM_EXACT_R8_RAW',dualSetProjectionVersion:dualProjector?.version||'',dualSetProjectionPolicy:dualProjector?'PURPOSE_SCORE_ONLY_SAME_HEAD_2LIGHT':'OFF',nativeSortPolicy:'EXIT_NORA',urlParams:[URL_PARENT,URL_CHILD],languageVersion:COPY_VERSION,
      capabilityAudit:state.capabilityAudit?Object.freeze({...state.capabilityAudit,unknown:[...state.capabilityAudit.unknown],missingKnown:[...state.capabilityAudit.missingKnown]}):null
    }),
    getTaxonomy:()=>state.taxonomy.map(p=>({...p,children:p.children.map(c=>({...c}))})),
    getOrders:()=>Object.freeze({source:state.lastSourceOrder.slice(),final:state.lastFinalOrder.slice(),renderedPage:state.lastRenderedPage.slice()}),
    select:async(parentKey,childKey)=>{await chooseParent(parentKey,{historyMode:'replace'});if(childKey)await chooseChild(childKey,{historyMode:'replace'});return publicApi.getState();},
    reset:async()=>{await reset({historyMode:'replace'});return publicApi.getState();},
    refreshRanking:async()=>{if(state.childKey)await applyRanking('API_REFRESH');return publicApi.getState();},
    waitForIdle:async(timeout=20000)=>{const start=performance.now();while(state.busy&&performance.now()-start<timeout)await sleep(40);return !state.busy;}
  });
  window.CANFOTO_R9_COLLECTION_NORA=publicApi;window.CANFOTO_R9_NORA=publicApi;
  window.dispatchEvent(new CustomEvent('canfoto:r9-collection-nora-ready',{detail:publicApi.getState()}));
  renderUi();await restoreFromUrl('BOOT_URL');
}

async function boot(){
  const roots=all(document,'[data-cf-nora-r9]');if(!roots.length)return;
  for(const root of roots){
    try{await bootRoot(root)}catch(error){root.dataset.cfNoraPolicyStatus='HOLD';root.dataset.cfNoraState='ERROR_FAIL_CLOSED';const status=root.querySelector('[data-cf-nora-status]');if(status)status.textContent='NORA seçenekleri şu anda yüklenemedi. Ürünleri normal sırada inceleyebilirsiniz.';root.querySelectorAll('button').forEach(b=>b.disabled=true);console.error('[CANFOTO R9 NORA]',error);}
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
